import {
  IOccasionGeniusEvent,
  IOccasionGeniusPrice,
  IOccasionGeniusRecurringEvent,
} from '../interfaces/occasion-genius-event.interface';
import { InitializeField } from './initialize-field.model';

export class OccasionGeniusEvent
  extends InitializeField<IOccasionGeniusEvent>
  implements IOccasionGeniusEvent
{
  uuid: string = '';
  recurring_event_uuid: string = '';
  umbrella_event_uuid: string = '';
  name: string = '';
  event_name_native?: string = '';
  description: string = '';
  event_description_native?: string = '';
  venue_uuid: string = '';
  area_uuid: string = '';
  start_date: string = '';
  end_date: string = '';
  instance_date: string = '';
  popularity_score: string = '';
  annual: string = '';
  event_uuid: string = '';
  flags?: string = '';
  event_dates: string = '';
  rrule?: string = '';
  latitude: string = '';
  longitude: string = '';
  source_url: string = '';
  image_url: string = '';
  image_url_2?: string = '';
  image_url_3?: string = '';
  image_url_4?: string = '';
  image_url_5?: string = '';
  image_alt_text_english?: string = '';
  image_2_alt_text_english?: string = '';
  image_3_alt_text_english?: string = '';
  image_4_alt_text_english?: string = '';
  image_5_alt_text_english?: string = '';
  ticket_url?: string = '';
  stated_covid_precautions?: string = '';
  virtual_address?: string = '';
  virtual_rule: string = '';
  travel_worthy?: string = '';
  cancelled?: string = '';
  minimum_price?: string = '';
  maximum_price?: string = '';
  address?: string = '';
  events?: OccasionGeniusEvent[] = [];

  protected excludedKeys: string[] = [];

  constructor(
    data: Partial<IOccasionGeniusEvent | IOccasionGeniusRecurringEvent> = {},
  ) {
    super();
    this.initializeFields(data);

    if (data?.events?.length) {
      this.events = this.mapToModelArray(data.events, OccasionGeniusEvent);
    }
  }

  protected getDefaultValue(key: string): any {
    switch (key) {
      case 'uuid':
      case 'recurring_event_uuid':
      case 'umbrella_event_uuid':
      case 'name':
      case 'event_name_native':
      case 'description':
      case 'event_description_native':
      case 'venue_uuid':
      case 'area_uuid':
      case 'start_date':
      case 'end_date':
      case 'instance_date':
      case 'popularity_score':
      case 'annual':
      case 'event_uuid':
      case 'flags':
      case 'event_dates':
      case 'rrule':
      case 'source_url':
      case 'image_url':
      case 'image_url_2':
      case 'image_url_3':
      case 'image_url_4':
      case 'image_url_5':
      case 'image_alt_text_english':
      case 'image_2_alt_text_english':
      case 'image_3_alt_text_english':
      case 'image_4_alt_text_english':
      case 'image_5_alt_text_english':
      case 'ticket_url':
      case 'stated_covid_precautions':
      case 'virtual_address':
      case 'virtual_rule':
      case 'travel_worthy':
      case 'cancelled':
      case 'maximum_price':
      case 'address':
      case 'latitude':
      case 'longitude':
        return '';
      case 'events':
        return [];
      default:
        return null;
    }
  }
}
